module.exports = __webpack_public_path__ + "img/16_56.b2f58df0.png";